import styled from 'styled-components';

import {
  BackgroundColor,
  FlexContainer,
  FontFamily,
  FontWeight,
  HeaderFontSize,
  Margin,
  Padding,
} from '@demandstar/components/styles';

import { CartWrapper } from './cart/styles';

export const Page = styled.div`
  background: ${BackgroundColor.BaseWhite};
  display: flex;
  flex-flow: row wrap;
  margin: ${Margin.None} auto;
  padding: 14rem ${Padding.Base};
  width: calc(100% - 2rem);

  @media (min-width: 75rem) {
    max-width: 100rem;
  }
             @media (min-width: 1000px) {
   padding-top: 17.5rem;
  }
      @media (min-width: 1400px) {
   padding-top: 20.5rem;
  }
         @media (min-width: 1600px) {
   padding-top: 21.5rem;
  }
            @media (min-width: 2300px) {
   padding-top: 25.5rem;
  }

  ${CartWrapper} {
    left: -3rem;
  }
`;

export const AddStateButtonWrapper = styled(FlexContainer)`
  padding: ${Padding.Base} 0;
  width: 100%;

  > button {
    font-family: ${FontFamily.Header};
    font-size: ${HeaderFontSize.H5};
    font-weight: ${FontWeight.Header};
    
  }
      @media screen and (max-width: 700px) {
      > button {
         font-family: ${FontFamily.Header};
         font-size: ${HeaderFontSize.H6};
         font-weight: ${FontWeight.Header};
         width:max-content; 
        }
     }
  }
`;
